import { useAuth } from "../auth.js";

/**
 * A standing marker that this is not production.
 *
 * Renders only when the server sets DEPLOYMENT_LABEL, so production is the
 * deployment with no badge -- nobody has to remember to turn it off, and a
 * forgotten label is a visible mistake rather than a silent one.
 *
 * It sits above the nav rather than inside a page because the risk it addresses
 * is being on the wrong deployment at all: two tabs are identical once you are
 * past the sign-in page, and the mistake that follows -- deleting a real course
 * believing it is seeded data -- is only obvious afterwards. A per-page notice
 * would be absent on exactly the screens where it matters most.
 */
export function DeploymentBanner() {
  const { deploymentLabel } = useAuth();
  if (!deploymentLabel) return null;

  return (
    <div className="deployment-banner" role="status">
      <strong>{deploymentLabel}</strong>
    </div>
  );
}
